/* global api */
import * as types from './branch-user-types'
import { BranchUser, LogEntry, User } from '../../models'
import localforage from 'localforage'

const state = {
  branchUsers: [],
  allBfmsWithBranchUsers: [],
  searchAllBfms: false,
  usersLoaded: false
}

const mutations = {
  commitBranchUsers (state, meta) {
    state.branchUsers = meta
  },
  commitAllBfmsWithBranchUsers (state, meta) {
    state.allBfmsWithBranchUsers = meta
    state.usersLoaded = true
  },
  commitSearchAllBfms (state, meta) {
    state.searchAllBfms = meta
  }
}
const actions = {
  async fetchBranchUsers ({ commit, dispatch, rootState }, meta) {
    try {
      const startLogEntry = new LogEntry('branch-users/fetchBranchUsers', 'Start')
      await dispatch('support/addLog', startLogEntry, { root: true })

      const metaLogEntry = new LogEntry('branch-users/fetchBranchUsers meta', meta)
      await dispatch('support/addLog', metaLogEntry, { root: true })

      const user = new User(rootState.authentication.user)
      const method = 'post'
      const result = await api.call(method, rootState.apiUrl + 'getBranchUsers', meta)
      const allBfmsWithBranchUsers = []
      const branchUsers = []
      if (result.message) {
        console.log('RAW MESSAGE')
        console.log(result.message)
      }
      for (const [key, branchUserType] of Object.entries(result.message)) {
        branchUserType.forEach(branchUser => {
          if (
            branchUser.item_name !== undefined &&
            branchUser.item_name !== null &&
            branchUser.item_name.trim().length > 0
          ) {
            branchUser.type = key
            branchUser.search_data = branchUser.item_name

            if (key === types.BFM) {
              branchUser.search_data += ' - BFM'
              if (branchUser.branch_name !== null && branchUser.branch_name.length > 0) {
                branchUser.search_data += ' - ' + branchUser.branch_name
              }

              if (parseInt(branchUser.C_branch_item_id_primary) === 0) {
                branchUser.search_data += ' - Branch Support'
              }
            }

            if (key === types.RESIDENT) {
              branchUser.search_data += ' - Resident'
            }

            if (key === types.CONTACT) {
              branchUser.search_data += ' - Contact'
              if (branchUser.resident_name.length > 0) {
                branchUser.search_data += ' - ' + branchUser.resident_name
              }
              if (branchUser.relationship_type.length > 0) {
                branchUser.search_data += ' - ' + branchUser.relationship_type
              }
            }

            if (key === types.PROVIDER) {
              branchUser.search_data += ' - Provider'
              if (branchUser.C_referral_org_type_item_name.length > 0) {
                branchUser.search_data += ' - ' + branchUser.C_referral_org_type_item_name
              }
              if (branchUser.C_referral_organization_item_name.length > 0) {
                branchUser.search_data += ' - ' + branchUser.C_referral_organization_item_name
              }
              if (branchUser.title.length > 0) {
                branchUser.search_data += ' - ' + branchUser.title
              }
            }

            if (key === types.VISITOR) {
              branchUser.search_data += ' - Visitor'
              if (branchUser.visitorType !== undefined && branchUser.visitorType !== null && branchUser.visitorType !== '') {
                branchUser.search_data += ' - ' + mapVisitorType(branchUser.visitorType)
              }
              if (branchUser.visitor_type !== undefined && branchUser.visitor_type !== null && branchUser.visitor_type !== '') {
                branchUser.search_data += ' - ' + mapVisitorType(branchUser.visitor_type)
              }
            }

            if (parseInt(branchUser.item_id) !== parseInt(user.id)) {
              allBfmsWithBranchUsers.push(new BranchUser(branchUser))
            }

            if (key !== types.BFM) {
              branchUsers.push(new BranchUser(branchUser))
            }

            /**
             * First search is only BFM's in their branch.
             * And if it is not themself.
             */
            if (
              parseInt(branchUser.C_branch_item_id_primary) === parseInt(user.primaryBranchId) &&
              key === types.BFM &&
              parseInt(branchUser.item_id) !== parseInt(user.id)
            ) {
              branchUsers.push(new BranchUser(branchUser))
            }
          }
        })
      }
      if (rootState.isSelf) {
        await dispatch('cacheBranchUsers', allBfmsWithBranchUsers)
      }
      await commit('commitAllBfmsWithBranchUsers', allBfmsWithBranchUsers)
      await commit('commitBranchUsers', branchUsers)
      await dispatch('setInitStepComplete', 'fetchBranchUsers', { root: true })

      const endLogEntry = new LogEntry('branch-users/fetchBranchUsers', 'End: ' + result.success)
      await dispatch('support/addLog', endLogEntry, { root: true })

      return result.success
    } catch (error) {
      const logEntry = new LogEntry('branch-users/fetchBranchUsers error', error)
      await dispatch('support/addLog', logEntry, { root: true })
      await dispatch('setInitFailure', true, { root: true })
    }
  },
  setSearchAllBfms ({ commit }, meta) {
    commit('commitSearchAllBfms', meta)
  },
  async cacheBranchUsers ({ rootState }, meta) {
    console.log('Running saveCache')
    await localforage.setItem('cached_bfms', meta)
  },
  replaceBfm ({ commit, dispatch }, meta) {
    console.log(meta)
    const allBfmsWithBranchUsersTemp = this.state.branchUsers.allBfmsWithBranchUsers
    console.log(allBfmsWithBranchUsersTemp)
    allBfmsWithBranchUsersTemp.forEach((element, index, array) => {
      if (element.itemId === meta.itemId) {
        array[index] = meta
        console.log('REPLACED')
      }
    })
    commit('commitAllBfmsWithBranchUsers', allBfmsWithBranchUsersTemp)
    dispatch('cacheBranchUsers', allBfmsWithBranchUsersTemp)
  }

}

const getters = {
  check: state => state.branchUsers.length > 0,
  count: state => state.branchUsers.length,
  allUsers: state => {
    const branchUsersTmp = state.branchUsers
    return branchUsersTmp
  },
  allBfmsWithBranchUsers: state => {
    return state.allBfmsWithBranchUsers
  },
  userStore: state => () => {
    if (state.searchAllBfms) {
      return state.allBfmsWithBranchUsers
    }
    return state.branchUsers
  },
  bfms: state => {
    return state.branchUsers.filter(user => user.type === types.BFM)
  },
  residents: state => {
    return state.branchUsers.filter(user => user.type === types.RESIDENT)
  },
  contacts: state => {
    return state.branchUsers.filter(user => user.type === types.CONTACT)
  },
  providers: state => {
    return state.branchUsers.filter(user => user.type === types.PROVIDER)
  },
  visitors: state => {
    return state.branchUsers.filter(user => user.type === types.VISITOR)
  },
  searchingAllBfms: state => {
    return state.searchAllBfms
  },
  usersLoaded: state => {
    return state.usersLoaded
  },
  newVisitors: state => {
    return state.newVisitors
  }
}

function mapVisitorType (index) {
  const obj = []
  obj[8] = 'Family/friend'
  obj[1] = 'MD/DPM/NP/PA/OD'
  obj[2] = 'Home Health'
  obj[3] = 'Hospice'
  obj[4] = 'PT/OT/ST – Part B only'
  obj[5] = 'Agency Staff'
  obj[6] = 'Private Duty Caregiver'
  obj[7] = 'Other'
  return obj[index]
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
